<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="推广专员名称" prop="nickName">
                <a-input v-model="queryParam.nickName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="订单状态" prop="orderDetailStatus">
                <a-select placeholder="请选择" v-model="queryParam.orderDetailStatus">

                  <a-select-option
                    v-for="(item, index) in this.customDict.OrderSellStatusEnum"
                    :value="item.type"
                    :key="index"
                  >
                    {{ item.name }}
                  </a-select-option>

                  <!-- <a-select-option
                    v-if="orderStatusSelect.length > 0"
                    v-for="(item) in orderStatusSelect"
                    :key="item.value"
                    :value="item.value"
                    >{{ item.label }}</a-select-option
                  > -->
                </a-select> 
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="下单时间" prop="createTime">
                <a-date-picker
                  style="width: 100%"
                  type="date"
                  v-model="queryParam.createTime"
                  valueFormat="YYYY-MM-DD"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />{{ $t('通用.按钮.查询') }}</a-button
                >
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />{{ $t('通用.按钮.重置') }}</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :height="500"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
      >
        <!-- <span slot="operation" slot-scope="text, record">
          <a @click="promotionManagerDetail(record)"> 查看详情 </a>
        </span> -->
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import moment from 'moment'
import { kickbackManager, getSelectParma } from '@/api/promotion/index'
import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'promotionSpecialist',
  mixins: [tableMixin],
  data() {
    return {
      orderStatusSelect: [],
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      orderDetailStatus:null,
      // 查询参数
      queryParam: {
        orderDetailStatus: null,
        nickName: null,
        id: null,
        createTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '推广专员',
          dataIndex: 'nickName',
          align: 'center',
        },
        {
          title: 'ID',
          dataIndex: 'kickbackUserId',
          align: 'center',
        },
        {
          title: '上级',
          dataIndex: 'ancestorId',
          align: 'center',
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          align: 'center',
        },
        {
          title: '分佣层级',
          dataIndex: 'level',
          align: 'center',
        },
        {
          title: '订单号',
          dataIndex: 'orderId',
          align: 'center',
        },
        {
          title: '购买人',
          dataIndex: 'puyerUserId',
          align: 'center',
        },
        {
          title: '商品',
          dataIndex: 'goodsName',
          align: 'center',
        },
        {
          title: '商品金额',
          dataIndex: 'goodsAmount',
          align: 'center',
        },
        {
          title: '佣金',
          dataIndex: 'withdrawableAmount',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'orderDetailStatusStr',
          align: 'center',
        },
        {
          title: '佣金状态',
          dataIndex: 'statusStr',
          align: 'center',
        },
        {
          title: '下单时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '完成时间',
          dataIndex: 'completionTime',
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getSelectParma()
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  methods: {
    moment,
    getSelectParma() {
      getSelectParma().then((response) => {
        this.orderStatusSelect = response.data.orderStatusSelect
      })
    },
    /** 查询用户-用户搜索记录列表 */
    getList() {
      this.loading = true
      kickbackManager(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getTotal(total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        orderDetailStatus: null,
        id: null,
        nickName: null,
        createTime: null,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>
